/**
 * Loads a Google font and ensures it's fully available before resolving
 * @param {string} font - The font name in Google Fonts format
 * @param {string} linkId - The ID to use for the link element
 * @returns {Promise} - Resolves when the font is loaded and ready
 */
export const loadFont = (font, linkId) => {
  return new Promise((resolve) => {
    const existingLink = document.getElementById(linkId);

    if (existingLink) {
      existingLink.parentNode.removeChild(existingLink);
    }

    // Create a test element to check when the font is actually available
    const testElement = document.createElement("span");
    testElement.style.position = "absolute";
    testElement.style.visibility = "hidden";
    testElement.style.fontFamily = "monospace"; // Default font
    testElement.textContent = "Font Test";
    document.body.appendChild(testElement);

    // Get the width with the default font
    const defaultWidth = testElement.offsetWidth;

    // Create and add the font link
    const link = document.createElement("link");
    link.id = linkId;
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
      font
    )}&display=swap`;
    link.rel = "stylesheet";
    document.head.appendChild(link);

    // Parse the font family name (remove weights, etc.)
    const fontFamily = font.split(":")[0].replace(/\+/g, " ");

    // Check if the font is loaded by monitoring width changes
    const checkFont = () => {
      // Check if the element is still in the DOM before proceeding
      if (!document.body.contains(testElement)) {
        return;
      }

      testElement.style.fontFamily = `"${fontFamily}", monospace`;

      if (testElement.offsetWidth !== defaultWidth) {
        // Font is loaded and applied
        document.body.removeChild(testElement);
        resolve();
      } else {
        // Check again in a short while
        setTimeout(checkFont, 50);
      }
    };

    // Start checking after the link has loaded
    link.onload = () => {
      setTimeout(checkFont, 100);
    };

    // Set a timeout to prevent infinite waiting
    setTimeout(() => {
      if (document.body.contains(testElement)) {
        document.body.removeChild(testElement);
        resolve();
      }
    }, 3000);
  });
};

